import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPlus, FiMinus } = FiIcons;

const infoData = [
  {
    title: "Shipping Protocol",
    content: "All orders dispatch within 48 hours of drop completion. Domestic transit 3-5 days. International transit 7-14 days. Signature required on all deliveries."
  },
  {
    title: "Return Policy",
    content: "All sales are final on limited drops. No returns or exchanges unless the product is defective upon arrival. Inspect gear immediately."
  },
  {
    title: "FAQ",
    content: "Q: Will these restock? A: No. Limited runs only.\nQ: Are bots allowed? A: Orders flagged as bot activity will be cancelled without notice."
  }
];

const InfoSection = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="info" className="py-20 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto border-t border-[#333]">
      <h2 className="text-4xl font-black uppercase tracking-tighter mb-10 text-center">Intel</h2>
      
      <div className="space-y-4">
        {infoData.map((item, idx) => (
          <div key={idx} className="border border-[#333] bg-[#0A0A0A]">
            <button 
              onClick={() => setOpenIndex(openIndex === idx ? -1 : idx)}
              className="w-full px-6 py-5 flex justify-between items-center text-left hover:bg-[#111] transition-colors"
            >
              <span className="font-bold uppercase tracking-widest text-[#737373] group-hover:text-white">
                {item.title}
              </span>
              <SafeIcon 
                icon={openIndex === idx ? FiMinus : FiPlus} 
                className={`w-5 h-5 ${openIndex === idx ? 'text-acid' : 'text-[#737373]'}`} 
              />
            </button>
            
            {openIndex === idx && (
              <div className="px-6 pb-6 text-sm text-gray-400 leading-relaxed font-mono whitespace-pre-line">
                <div className="h-[1px] w-full bg-[#333] mb-4"></div>
                {item.content}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default InfoSection;